import type { DemoPath } from '@/contexts/DemoPathContext';

export function shouldShowSurgeryRevenueForDemoPath({ demoPath }: { demoPath: DemoPath }) {
  return demoPath === 'admin';
}
